<div class="banner" [ngStyle]="{'color': colour, 'background-color': top, 'background-image': 'linear-gradient(to bottom, '+top+', '+bottom+')' }" [ngClass]="{'has-picture': !!picture && picture.length > 0}">
	<a *ngIf="!!link" target="_blank" [href]="safe_url(link)">
		<div class="content">
			<div class="text">
				<h2>
					<img *ngIf="!!icon" [src]="icon" alt="" />
					{{heading}}
				</h2>
				<p [innerHtml]="html"></p>
			</div>
			<picture *ngIf="picture && picture.length > 0" [ngStyle]="{'object-position': align}">
				<source *ngFor="let src of picture" [srcset]="'/assets/' + src[0]" [type]="src[1]">
				<img loading="lazy" [src]="'/assets/'+picture[picture.length - 1][0]" [ngStyle]="{'object-position': align}">
			</picture>
		</div>
	</a>

	<ng-container *ngIf="!link">
		<div class="content">
			<div class="text">
				<h2>
					<img *ngIf="!!icon" [src]="icon" alt="" />
					{{heading}}
				</h2>
				<p [innerHtml]="html"></p>
			</div>
			<picture *ngIf="picture && picture.length > 0" [ngStyle]="{'object-position': align}">
				<source *ngFor="let src of picture" [srcset]="'/assets/' + src[0]" [type]="src[1]">
				<img loading="lazy" [src]="'/assets/'+picture[picture.length - 1][0]" [ngStyle]="{'object-position': align}">
			</picture>
		</div>
	</ng-container>
</div>
